import React, { useRef } from 'react';
import { LIST_TABS, TABPANEL_ID } from '../../constants/shipments';

// Tabs Aktivní / Ke kontrole (with a count) / Doručené / Vše. Arrow keys move between tabs, Home / End jump.
const ListTabs = ({ value, onChange, reviewCount }) => {
  const refs = useRef({});

  const onKeyDown = (e) => {
    const idx = LIST_TABS.findIndex((t) => t.value === value);
    let next = idx;
    if (e.key === 'ArrowRight') next = (idx + 1) % LIST_TABS.length;
    else if (e.key === 'ArrowLeft') next = (idx - 1 + LIST_TABS.length) % LIST_TABS.length;
    else if (e.key === 'Home') next = 0;
    else if (e.key === 'End') next = LIST_TABS.length - 1;
    else return;
    e.preventDefault();
    onChange(LIST_TABS[next].value);
    refs.current[LIST_TABS[next].value]?.focus();
  };

  return (
    <div className="shp-tabs" role="tablist" aria-label="Zásilky podle stavu" onKeyDown={onKeyDown}>
      {LIST_TABS.map((tab) => {
        const selected = tab.value === value;
        return (
          <button
            key={tab.value} ref={(el) => { refs.current[tab.value] = el; }} type="button" role="tab" id={`shp-tab-${tab.value}`}
            className="shp-tab" aria-selected={selected} aria-controls={TABPANEL_ID} tabIndex={selected ? 0 : -1} onClick={() => onChange(tab.value)}
          >
            {tab.label}
            {tab.value === 'review' && reviewCount > 0 && (
              <span className="shp-count"><span aria-hidden="true">{reviewCount > 99 ? '99+' : reviewCount}</span><span className="shp-sr"> ke kontrole: {reviewCount}</span></span>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default ListTabs;
